import React, { Fragment, useEffect, useState } from "react";
import styles from "Components/Topology/topology.module.scss";
import { Form, Select, Row, Col, Input, Divider, InputNumber, Button, Radio, FormInstance } from "antd";
import { CharacterVerify, IPV4Verify, MaskVerify } from "Utility/RegExp";
import { useAppSelector } from "store/hook";
import { setProtocolOption, setFields } from "./setFields";

import { MinusCircleOutlined } from "@ant-design/icons";

const { Option } = Select;
const interfaceOptions = ["wan-ethernet", "sim1-apn", "sim1-apn2", "sim2-apn", "sim2-apn2"];
// for M335-W-A
const M335_A_interfaceOptions = ["wan-ethernet"];

const protocolOptions = {
  "sim-apn": ["dhcp_v4"],
  "wan-ethernet": ["pppoe_client", "static_ipv4", "dhcp_v4"],
};
const bridgeOptions = ["NET1", "NET2", "NET3", "NET4", "NET5", "NET6", "NET7", "NET8"];

const BulkConfigFWan_M335 = React.memo(
  ({ SubmitConfigonFinish, form }: { SubmitConfigonFinish: (value: any) => void; form: FormInstance<any> }) => {
    const { formData, nodeInf, selectedModel, importSource } = useAppSelector((state) => state.topology);
    const [WanPriority, setWanPriority] = useState("Auto");
    const [WanEthernetType, setWanEthernetType] = useState("dhcp");
    const [WanDHCPServer1, setWanDHCPServer1] = useState("");
    const [WanDHCPServer2, setWanDHCPServer2] = useState("");
    const [WanDHCPServer3, setWanDHCPServer3] = useState("");
    const [activeProfile, setActiveProfile] = useState(formData?.wan?.connect_table?.active_profile);
    const [protocal, setProtocal] = useState({});
    const [rowNumber, setRowNumber] = useState({ Table1: 0, Table2: 0, Table3: 0 });
    const [profileInterface, setProfileInterface] = useState<any>({});

    useEffect(() => {
      //import Wan priority
      if (formData?.wan?.priority?.order?.length === 3) {
        setWanPriority("Auto");
        form.setFieldsValue({ Priority: "Auto" });
      } else if (formData?.wan?.priority?.order?.length) {
        setWanPriority(formData?.wan?.priority?.order?.[0]);
        form.setFieldsValue({ Priority: formData?.wan?.priority?.order?.[0] });
      }

      const tableNumber1 = formData?.wan?.connect_table?.profile[0]?.profile_list?.length;
      const tableNumber2 = formData?.wan?.connect_table?.profile[1]?.profile_list?.length;
      const tableNumber3 = formData?.wan?.connect_table?.profile[2]?.profile_list?.length;
      setRowNumber({
        Table1: tableNumber1,
        Table2: tableNumber2,
        Table3: tableNumber3,
      });

      setWanDHCPServer1(formData.wan?.ethernet?.dhcp?.dns?.ipv4?.[0].type);
      setWanDHCPServer2(formData.wan?.ethernet?.dhcp?.dns?.ipv4?.[1].type);
      setWanDHCPServer3(formData.wan?.ethernet?.dhcp?.dns?.ipv4?.[2].type);

      //折疊的form再打開時會重新setField到舊的資料, 避免Import後 NewConfig又看到舊資料
      if (importSource === "NewConfig") {
        return;
      }

      const profileInterfaceObj = setProtocolOption(formData?.wan);
      setProfileInterface(profileInterfaceObj);

      setFields(formData?.wan, form);

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData]);

    const props = { profileInterface, setProfileInterface, rowNumber, setRowNumber, form, protocal, setProtocal };

    return (
      <Form onFinish={SubmitConfigonFinish} form={form} scrollToFirstError layout="vertical">
        <div className="formwrap">
          <Row gutter={24} justify="space-around">
            <Col xs={24} sm={24} md={24} lg={10}>
              <h2>Connection Table</h2>
              <Divider className={styles.divider} />

              <Form.Item name="active_profile" label="Profile" rules={[{ required: true, message: "required!" }]}>
                <Select onChange={(value: number) => setActiveProfile(value)}>
                  {[1, 2, 3].map((item) => (
                    <Option key={item} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <div className={activeProfile === 1 ? "block" : "hidden"}>
                <Form.Item name="profile_name_1" label="Name" rules={[{ required: true, message: "required!" }]}>
                  <Input placeholder="Profile Name" />
                </Form.Item>
                <WANProfile Table={"Table1"} {...props} selectedModel={selectedModel} />
              </div>

              <div className={activeProfile === 2 ? "block" : "hidden"}>
                <Form.Item name="profile_name_2" label="Name" rules={[{ required: true, message: "required!" }]}>
                  <Input placeholder="Profile Name" />
                </Form.Item>
                <WANProfile Table={"Table2"} {...props} selectedModel={selectedModel} />
              </div>

              <div className={activeProfile === 3 ? "block" : "hidden"}>
                <Form.Item name="profile_name_3" label="Name" rules={[{ required: true, message: "required!" }]}>
                  <Input placeholder="Profile Name" />
                </Form.Item>
                <WANProfile Table={"Table3"} {...props} selectedModel={selectedModel} />
              </div>
            </Col>

            <Col xs={24} sm={24} md={24} lg={10}>
              <h2>Ethernet</h2>
              <Divider className={styles.divider} />
              <Form.Item>
                <Radio.Group
                  onChange={(e) => {
                    setWanEthernetType(e.target.value);
                  }}
                  style={{ marginBottom: 16 }}
                  defaultValue={"dhcp"}
                >
                  <Radio.Button id={"dhcp"} value={"dhcp"}>
                    DHCP Client
                  </Radio.Button>
                  <Radio.Button id={"pppoe"} value={"pppoe"}>
                    PPPoE Client
                  </Radio.Button>
                  <Radio.Button id={"static"} value={"static"}>
                    Static IPv4
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
              <div className={WanEthernetType === "dhcp" ? "block" : "hidden"}>
                <h3>DNS Server Configuration</h3>

                <Form.Item
                  name="WAN_ipv4_type_1"
                  label="IPv4 DNS Server #1"
                  // rules={[{ required: true, message: "required!" }]}
                  // placeholder="DNS Server"
                  initialValue={"ISP"}
                >
                  <Select
                    onChange={(value: string) => {
                      setWanDHCPServer1(value);
                    }}
                  >
                    <Option key={1} value={"ISP"}>
                      ISP
                    </Option>
                    <Option key={2} value={"manual"}>
                      Manual
                    </Option>
                    <Option key={3} value={"none"}>
                      None
                    </Option>
                  </Select>
                </Form.Item>
                {WanDHCPServer1 === "manual" && (
                  <Form.Item
                    name="WAN_ipv4_address_1"
                    label="Address #1"
                    rules={[{ required: true, message: "required!" }, CharacterVerify]}
                    initialValue={"192.0.0.0"}
                  >
                    <Input placeholder="Input adress" disabled={WanDHCPServer1 !== "manual"} />
                  </Form.Item>
                )}
                <Form.Item
                  name="WAN_ipv4_type_2"
                  label="IPv4 DNS Server #2"
                  rules={[{ required: true, message: "required!" }, CharacterVerify]}
                  initialValue={"ISP"}
                >
                  <Select
                    onChange={(value: string) => {
                      setWanDHCPServer2(value);
                    }}
                  >
                    <Option key={1} value={"ISP"}>
                      ISP
                    </Option>
                    <Option key={2} value={"manual"}>
                      Manual
                    </Option>
                    <Option key={3} value={"none"}>
                      None
                    </Option>
                  </Select>
                </Form.Item>
                {WanDHCPServer2 === "manual" && (
                  <Form.Item
                    name="WAN_ipv4_address_2"
                    label="Address #2"
                    rules={[{ required: true, message: "required!" }, CharacterVerify]}
                    initialValue={"192.0.0.0"}
                  >
                    <Input placeholder="Input adress" disabled={WanDHCPServer2 !== "manual"} />
                  </Form.Item>
                )}

                <Form.Item
                  name="WAN_ipv4_type_3"
                  label="IPv4 DNS Server #3"
                  rules={[{ required: true, message: "required!" }]}
                  // placeholder={"DNS Server"}
                  initialValue={"ISP"}
                >
                  <Select
                    onChange={(value: string) => {
                      setWanDHCPServer3(value);
                    }}
                  >
                    <Option key={1} value={"ISP"}>
                      ISP
                    </Option>
                    <Option key={2} value={"manual"}>
                      Manual
                    </Option>
                    <Option key={3} value={"none"}>
                      None
                    </Option>
                  </Select>
                </Form.Item>
                {WanDHCPServer3 === "manual" && (
                  // <Col xs={24} sm={24} md={24} lg={7}>
                  <Form.Item
                    name="WAN_ipv4_address_3"
                    label="Address #3"
                    rules={[{ required: true, message: "required!" }, CharacterVerify]}
                    initialValue={"192.0.0.0"}
                  >
                    <Input placeholder="Input adress" disabled={WanDHCPServer3 !== "manual"} />
                  </Form.Item>
                )}
              </div>
              <div className={WanEthernetType === "pppoe" ? "block" : "hidden"}>
                <h3>PPPoE Client Configuration</h3>
                <Form.Item
                  name="WAN_username"
                  label="User Name"
                  rules={[{ required: true, message: "required!" }, CharacterVerify]}
                >
                  <Input placeholder="User Name" maxLength={30} />
                </Form.Item>
                <Form.Item name="WAN_password" label="Password" rules={[CharacterVerify]}>
                  <Input placeholder="Password" maxLength={30} />
                </Form.Item>
                <Form.Item name="WAN_service_name" label="Service Name" rules={[CharacterVerify]}>
                  <Input placeholder="Service Name" maxLength={30} />
                </Form.Item>
              </div>
              <div className={WanEthernetType === "static" ? "block" : "hidden"}>
                <h3>Static IPv4 Configuration</h3>
                <Form.Item
                  name="WAN_static_ipv4_address"
                  label="IP Address"
                  rules={[{ required: true, message: "required!" }, IPV4Verify]}
                >
                  <Input placeholder="192.0.0.0" maxLength={30} />
                </Form.Item>
                <Form.Item
                  name="WAN_static_netmask"
                  label="IP Mask"
                  rules={[{ required: true, message: "required!" }, MaskVerify]}
                >
                  <Input placeholder="255.255.255.0" maxLength={30} />
                </Form.Item>
                <Form.Item
                  name="WAN_static_gateway"
                  label="Gateway"
                  rules={[{ required: true, message: "required!" }, IPV4Verify]}
                >
                  <Input placeholder="192.0.0.0" maxLength={30} />
                </Form.Item>
                <h3>DNS Server Configuration</h3>
                <Form.Item name="WAN_static_ipv4_dns_address1" label="IPv4 DNS Server #1" rules={[CharacterVerify]}>
                  <Input placeholder="DNS Address" maxLength={30} />
                </Form.Item>
                <Form.Item name="WAN_static_ipv4_dns_address2" label="IPv4 DNS Server #2" rules={[CharacterVerify]}>
                  <Input placeholder="DNS Address" maxLength={30} />
                </Form.Item>
                <Form.Item name="WAN_static_ipv4_dns_address3" label="IPv4 DNS Server #3" rules={[CharacterVerify]}>
                  <Input placeholder="DNS Address" maxLength={30} />
                </Form.Item>
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={10}></Col>
          </Row>
        </div>
      </Form>
    );
  }
);
export default BulkConfigFWan_M335;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const assemble = (values: any) => {
  //Ethernet
  let ethernetObj: any = {};

  //dhcp
  let dhcpObj: any = { dns: {} };
  let ipv4Array = [
    {
      type: values.WAN_ipv4_type_1,
      address: values.WAN_ipv4_address_1 || "8.8.8.8",
    },
    {
      type: values.WAN_ipv4_type_2,
      address: values.WAN_ipv4_address_2 || "8.8.8.8",
    },
    {
      type: values.WAN_ipv4_type_3,
      address: values.WAN_ipv4_address_3 || "8.8.8.8",
    },
  ];

  dhcpObj.dns.ipv4 = ipv4Array;
  ethernetObj.dhcp = dhcpObj;

  //pppoe
  let pppoeObj: any = {};
  pppoeObj.username = values.WAN_username;
  if (values.WAN_password) {
    pppoeObj.password = values.WAN_password;
  }
  pppoeObj.service_name = values.WAN_service_name;
  ethernetObj.pppoe = pppoeObj;

  //static
  let ipv4: any = {
    address: values.WAN_static_ipv4_address,
    netmask: values.WAN_static_netmask,
    gateway: values.WAN_static_gateway,
  };

  let DNSArray = [
    { address: values.WAN_static_ipv4_dns_address1 || "" },
    { address: values.WAN_static_ipv4_dns_address2 || "" },
    { address: values.WAN_static_ipv4_dns_address3 || "" },
  ];
  ipv4.dns = DNSArray;
  ethernetObj.static = {};
  ethernetObj.static.ipv4 = ipv4;

  //connect_table
  let connect_table: any = {};
  connect_table.active_profile = values.active_profile;

  let profile_list = [
    { profile_name: values.profile_name_1, profile_list: values.Table1 },
    { profile_name: values.profile_name_2, profile_list: values.Table2 },
    { profile_name: values.profile_name_3, profile_list: values.Table3 },
  ];
  connect_table.profile = profile_list;

  const wanObj = { connect_table, ethernet: ethernetObj };

  return wanObj;
};

interface WANProfileProps {
  Table: string;
  profileInterface: any;
  setProfileInterface: (arg: any) => void;
  rowNumber: any;
  setRowNumber: any;
  form: any;
  protocal: any;
  setProtocal: (arg: any) => void;
  selectedModel?: string;
}

const WANProfile = ({
  Table,
  profileInterface,
  setProfileInterface,
  rowNumber,
  setRowNumber,
  form,
  protocal,
  setProtocal,
  selectedModel,
}: WANProfileProps) => {
  return (
    <Form.List name={Table}>
      {(fields, { add, remove }) => (
        <>
          {fields.map((field) => (
            <Row gutter={24} justify="start" key={field.key}>
              <Form.Item
                {...field}
                name={[field.name, "mode"]}
                // fieldKey={[field.fieldKey, "mode"]}
                label="Mode"
                initialValue="on"
                style={{ display: "none" }}
              >
                <Select placeholder={"ON/OFF"}>
                  <Option value="on">ON</Option>
                </Select>
              </Form.Item>

              <Col xs={24} sm={24} md={24} lg={24} xl={7}>
                <Form.Item
                  {...field}
                  name={[field.name, "interface"]}
                  // fieldKey={[field.fieldKey, "interface"]}
                  label="Interface"
                  style={{ minWidth: "100px" }}
                  rules={[
                    {
                      required: true,
                      message: "required!",
                    },
                  ]}
                >
                  <Select
                    placeholder={"Interface"}
                    onChange={(value) => {
                      const key = JSON.stringify([Table, field.key, "interface"]);
                      setProfileInterface({ ...profileInterface, [key]: value });
                    }}
                  >
                    {selectedModel === "M335-W-A"
                      ? M335_A_interfaceOptions.map((item: string) => (
                          <Option
                            key={item}
                            value={item}
                            disabled={form
                              .getFieldValue([Table])
                              ?.map((item: any) => item?.interface)
                              .includes(item)}
                          >
                            {item.toUpperCase().replace("-", " ")}
                          </Option>
                        ))
                      : interfaceOptions.map((item: string) => (
                          <Option
                            key={item}
                            value={item}
                            disabled={form
                              .getFieldValue([Table])
                              ?.map((item: any) => item?.interface)
                              .includes(item)}
                          >
                            {item.toUpperCase().replace("-", " ")}
                          </Option>
                        ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={7}>
                <Form.Item
                  {...field}
                  name={[field.name, "protocol"]}
                  // fieldKey={[field.fieldKey, "protocol"]}
                  label="Protocol"
                  rules={[
                    {
                      required: true,
                      message: "required!",
                    },
                  ]}
                >
                  <Select
                    // placeholder={"ON/OFF"}
                    onChange={(value) => {
                      const key = JSON.stringify([Table, field.key]);
                      setProtocal({ ...protocal, [key]: value });
                    }}
                  >
                    {profileInterface[`${JSON.stringify([Table, field.key, "interface"])}`] !== "wan-ethernet"
                      ? protocolOptions["sim-apn"].map((item: string) => (
                          <Option key={item} value={item}>
                            {item.toUpperCase()}
                          </Option>
                        ))
                      : protocolOptions["wan-ethernet"].map((item: string) => (
                          <Option key={item} value={item}>
                            {item.toUpperCase()}
                          </Option>
                        ))}
                  </Select>
                </Form.Item>
              </Col>
              {(profileInterface[`${JSON.stringify([Table, field.key, "interface"])}`] === "sim1-apn2" ||
                profileInterface[`${JSON.stringify([Table, field.key, "interface"])}`] === "sim2-apn2") && (
                <Col xs={24} sm={24} md={24} lg={24} xl={7}>
                  <Form.Item
                    {...field}
                    name={[field.name, "management"]}
                    // fieldKey={[field.fieldKey, "management"]}
                    label="Management"
                    rules={[
                      {
                        required: true,
                        message: "required!",
                      },
                    ]}
                  >
                    <Select placeholder={"ON/OFF"}>
                      <Option key={"on"} value={"on"}>
                        ON
                      </Option>
                      <Option key={"off"} value={"off"}>
                        OFF
                      </Option>
                    </Select>
                  </Form.Item>
                </Col>
              )}

              {protocal[`${JSON.stringify([Table, field.key])}`] === "bridge" && (
                <Col xs={24} sm={24} md={24} lg={24} xl={7}>
                  <Form.Item
                    {...field}
                    name={[field.name, "bridge_interface"]}
                    // fieldKey={[field.fieldKey, "bridge_interface"]}
                    label="Bridge"
                    rules={[
                      {
                        required: true,
                        message: "required!",
                      },
                    ]}
                  >
                    <Select>
                      {bridgeOptions.map((item: string) => (
                        <Option key={item} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}

              {protocal[`${JSON.stringify([Table, field.key])}`] !== "bridge" && (
                <Fragment>
                  <Col xs={24} sm={24} md={24} lg={24} xl={7}>
                    <Form.Item
                      {...field}
                      name={[field.name, "priority"]}
                      // fieldKey={[field.fieldKey, "priority"]}
                      label="Priority"
                      rules={[
                        {
                          required: true,
                          message: "required!",
                        },
                      ]}
                    >
                      <InputNumber style={{ width: "100%" }} placeholder="1-20" min={1} max={20} step={1} />
                    </Form.Item>
                  </Col>
                </Fragment>
              )}

              <Col xs={24} sm={24} md={24} lg={24} xl={2} style={{ paddingBottom: "21px" }}>
                {/* <MinusCircleOutlined
                  className={styles.minusIcon}
                  onClick={() => {
                    remove(field.name);
                    setRowNumber({ ...rowNumber, [Table]: form.getFieldValue(Table)?.length });
                  }}
                /> */}
                <Button
                  danger
                  block
                  style={{ paddingBottom: "21px" }}
                  type="text"
                  icon={<MinusCircleOutlined />}
                  onClick={() => {
                    remove(field.name);
                    setRowNumber({ ...rowNumber, [Table]: form.getFieldValue(Table)?.length });
                  }}
                ></Button>
              </Col>
            </Row>
          ))}
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item>
              <Button
                type="dashed"
                disabled={rowNumber[Table] >= 5}
                onClick={() => {
                  add();
                  setRowNumber({ ...rowNumber, [Table]: form.getFieldValue(Table)?.length });
                }}
                block
                // icon={<PlusOutlined />}
              >
                Add
              </Button>
            </Form.Item>
          </Col>
        </>
      )}
    </Form.List>
  );
};
